var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg24Normalstqge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 93,
    viewBox: "0 0 100 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9291 91.1434C13.4643 87.3492 16.5499 82.614 18.6947 77.8484C20.1613 74.5913 21.2737 70.839 20.1042 67.4562C18.8966 63.9629 15.6166 61.7839 12.87 59.3763C6.61487 53.8793 2.82065 46.6642 2.11971 38.2796C1.43401 30.0968 3.71207 21.7465 8.48913 15.1485C13.9328 7.63246 22.1689 2.43255 31.3535 2.04018C39.5781 1.68971 48.0656 3.61349 54.7436 8.54293C61.4216 13.4724 66.0386 21.6284 65.7682 30.0549C65.6844 32.6987 65.3415 35.5901 66.252 38.1119C66.8234 39.7005 67.9929 41.19 69.0862 42.4395C69.7719 43.2204 70.4157 44.0623 71.2233 44.7023C72.0309 45.3423 72.469 45.7499 73.1014 46.5689C73.7337 47.388 74.1375 48.4546 73.9585 49.4832C73.8023 50.3632 73.2309 51.1251 72.5452 51.6774C71.8595 52.2298 71.0481 52.6031 70.2519 52.9688C69.8138 52.9269 69.5471 53.2965 69.4824 53.7422C69.4176 54.1879 69.5929 54.6336 69.8214 55.0183C70.05 55.4031 70.3319 55.7574 70.5109 56.165C70.8271 56.8811 70.7928 57.7535 70.4271 58.443C70.0576 59.1325 69.3224 59.6621 68.5643 59.7763C69.2386 59.723 69.9129 60.2259 70.1148 60.8849C70.3167 61.5477 70.1338 62.2868 69.7529 62.8582C69.3719 63.4296 68.8081 63.8525 68.2215 64.1915C67.551 64.5763 67.3605 65.1667 67.4596 65.9477C67.5548 66.7286 67.8976 67.46 67.9967 68.2371C68.2215 70.0352 67.0481 71.7952 65.5091 72.6866C63.9663 73.578 62.1301 73.7532 60.3587 73.7152C54.7055 73.6009 49.1132 71.4752 44.7476 67.7953",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.898 72.3362C49.3266 78.7399 47.3876 84.4731 45.5781 91.1435",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.286 53.4299V67.144",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1429 56.8582V63.7152",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0001 58.5725V62.001",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4288 58.5725V62.001",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Normalstqge);
export default __webpack_public_path__ + "static/media/24_Normalstqge.1ffd57f15a0cd81476225fe25d54d17a.svg";
export { ForwardRef as ReactComponent };